export function releaseLabel(state) {
  if (state === "released") return "Released";
  if (state === "processing") return "Available for processing";
  return "Locked until payment";
}

export function releaseTone(state) {
  if (state === "released") return "success";
  if (state === "processing") return "warning";
  return "danger";
}

export function isDownloadEnabled(row) {
  if (row?.download_available === false) return false;
  return String(row?.release_state || "processing") !== "locked";
}
